import { translatedOptions, visT } from "views/components/visualizations/visualizationTranslation";
import ScatterVisualization from "views/components/visualizations/scatter/ScatterVisualization";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  DEFAULT_AXIS_TYPE,
  axisTypes
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import ScatterVisualizationConfig from "views/logic/aggregationbuilder/visualizations/ScatterVisualizationConfig";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("vis_validation.scatter_plot_requires_metric");
const scatterChart = {
  type: ScatterVisualization.type,
  get displayName() {
    return visT("vis_types.scatter_plot");
  },
  component: ScatterVisualization,
  config: {
    createConfig: () => ({ axisType: DEFAULT_AXIS_TYPE, axisConfig: DEFAULT_AXIS_CONFIG }),
    fromConfig: (config) => {
      var _a;
      return {
        axisType: (_a = config == null ? void 0 : config.axisType) != null ? _a : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => ScatterVisualizationConfig.create(
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "axisType",
        get title() {
          return visT("vis_common.axis_type");
        },
        type: "select",
        get options() {
          return translatedOptions(axisTypes, "vis_common.axis_types");
        },
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default scatterChart;
